// extracted by mini-css-extract-plugin
export default {"content":"Rent_content__3yt23","cards":"Rent_cards__wllFl","card":"Rent_card__-dQHt"};